export default {
 taskRecord: {
   title: "Gantimpala ng Gawain",
   loading: "Naglo-load...",
   empty: "Walang gantimpala",
   completed: "Nakumpleto na ang gawain",
   desc: "Kumpletuhin ang gawain para makakuha ng gantimpala",
   close: "Isara",
   add: "Idagdag",
   addEmail: "Magdagdag ng Email",
   addPhoneNumber: "Magdagdag ng Numero ng Telepono",
   addBirthday: "Magdagdag ng Kaarawan",
   downloadNow: "I-download Ngayon",
   phone: "Numero ng telepono",
   email: "Email address",
   bank: "Bank card",
   birthday: "Kaarawan",
   download: "I-download",
   downloadApp: "I-download ang APP",
   registerBonus: "Registration Bonus",
   firstInviteBonus: "Bonus sa Unang Imbitasyon",
   invite: "Imbitahin",
   inviteNow: "Mag-imbita ng Kaibigan",
   go: "Pumunta",
   receive: "Kunin",
   received: "Nakuha na",
   task: "Gawain",
   claimRewards: 'Kunin ang Mga Gantimpala',
   receiveSuccess: 'Matagumpay na nakuha ang gantimpala',
   receiveFail: 'Hindi nakuha ang gantimpala'
 }
};
